var map = {
	"./Archer.png": 4009,
	"./Assassin.png": 179,
	"./Berserker.png": 7749,
	"./Blue Mage.png": 1740,
	"./BoardToCornholeSymbol.svg": 6929,
	"./Cleric.png": 1832,
	"./Custom.png": 2661,
	"./Gemini.png": 5749,
	"./Geomancer.png": 8923,
	"./Juggler.png": 8124,
	"./Mage.png": 9910,
	"./Merchant.png": 4752,
	"./Monk.png": 8245,
	"./Necromancer.png": 7639,
	"./Sapper.png": 1553,
	"./Squire.png": 5109,
	"./Warrior.png": 7876,
	"./chevronleft.svg": 3576,
	"./chevronright.svg": 6407,
	"./edit.svg": 7322,
	"./goldstar.png": 4690,
	"./party.svg": 1658,
	"./quest.svg": 3068,
	"./slingshot.png": 3477,
	"./star.png": 9388,
	"./stars2.png": 6939,
	"./stars3.png": 5810,
	"./undo.svg": 4192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;